<template>
  <div id="stats" v-if="stat">
    <div class="colums">

      <div class="column scrollMinimal">
        <h1>Statistiques</h1>
        <h1><b>{{ stat.totalJobs }}</b> Fiches</h1>
        <h3>{{ stat.totalSecteurs }} Secteurs</h3>
        <h3>{{ stat.totalExpertises }} Expertises</h3>
        <h3>{{ stat.totalMarques }} Marques</h3>
        <h3>{{ stat.totalTags }} Tags</h3>
        <h2>Secteurs :</h2>
        <ul>
          <li v-for="(count, secteur) in stat.secteurs" :key="secteur">{{ secteur }} : {{ count }}</li>
        </ul>
      </div>

      <div class="column scrollMinimal">
        <h2>Expertises :</h2>
        <ul>
          <li v-for="(count, item) in stat.expertises" :key="item">{{ item }} : {{ count }}</li>
        </ul>
        <h2>Tags :</h2>
        <ul>
          <li v-for="(count, item) in stat.tags" :key="item">{{ item }} : {{ count }}</li>
        </ul>
      </div>

      <div class="column scrollMinimal">
        <h2>Marques :</h2>
        <ul>
          <li v-for="(count, item) in stat.marques" :key="item">{{ item }} : {{ count }}</li>
        </ul>
        <h2>Fiches cachées ({{ fichesCachees.length }}) :</h2>
        <ul v-if="fichesCachees.length > 0">
          <li v-for="fiche in fichesCachees" :key="fiche.uuid">
            <b>{{ fiche.marque }}</b> — {{ fiche.fr?.titre || fiche.uuid }}
          </li>
        </ul>
        <p v-else style="font-size:11px; margin: 2px 20px;">Aucune fiche cachée</p>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Stats',
  data() {
    return {
      stat: null,
    };
  },
  computed: {
    ...mapState(['storeJobsDatas']),
    fichesCachees() {
      return this.storeJobsDatas?.jobs?.filter(j => j.visible === false) || [];
    }
  },
  mounted() {
    fetch('jobs_R_stat.json')
      .then(res => res.json())
      .then(data => {
        this.stat = data.stat;
      })
      .catch(() => {
        this.stat = null;
      });
  },
};
</script>
<style scoped>
#stats {
  color: var(--colorLight);
  height: 100%;
  width: 800px;
}
.colums {
  display: flex;
  flex-flow: row wrap;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  padding: 20px;
}
.column {
  height: 100%;
  width: 33.33%;
  overflow-y: auto;
}
ul{
    padding: 0;
    margin: 0 20px;
}
li{ 
    margin: 2px;
    font-size: 11px;
}
h3 {
    margin: 10px;
}
</style>